<template>
    <div class="form-curso">

        <div v-if="editCurso && !dados.id" class="loading-form" style="min-height: 200px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitCurso" v-if="!editCurso || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editCurso || dados.id">

                <el-row :gutter="10">                    
                    <el-col :xs="24" :sm="18" :md="18">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
                            <el-input :readonly="editCurso" v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Situação" prop="situacao" :rules="[$requiredChange]" key="situacao">
                            <el-select v-model="dados.situacao">
                                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                                <el-option :key="false" label="INATIVO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-row :gutter="10">                    
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Idade Mínima" prop="idade_minima" :rules="[$requiredBlur]" key="idade_minima">
                            <el-input v-model="dados.idade_minima" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Idade Máxima" prop="idade_maxima" :rules="[$requiredBlur]" key="idade_maxima">
                            <el-input v-model="dados.idade_maxima" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="(dados.tipo_ensino == 1 || dados.tipo_ensino == 2) ? 6 : 12" :md="(dados.tipo_ensino == 1 || dados.tipo_ensino == 2) ? 6 : 12">
                        <el-form-item label="Tipo de Ensino" prop="tipo_ensino" :rules="[$requiredChange]" key="tipo_ensino">
                            <el-select v-model="dados.tipo_ensino">
                                <el-option v-for="(item, i) in $CONSTANTS.TIPO_ENSINO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6" v-if="dados.tipo_ensino == 1 || dados.tipo_ensino == 2">
                        <el-form-item label="Etapa" prop="etapa" :rules="[$requiredChange]" key="etapa">
                            <el-select v-model="dados.etapa">
                                <el-option v-for="(item, i) in $CONSTANTS.ETAPA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">                    
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Curso Nacional Equivalente" prop="curso_nacional_equivalente" key="curso_nacional_equivalente">
                            <el-select v-model="dados.curso_nacional_equivalente" clearable>
                                <el-option v-for="(item, i) in $CONSTANTS.CURSO_NACIONAL" :key="i" :label="item" :value="parseInt(i)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">                    
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Curso Seguinte" prop="curso_seguinte_id" key="curso_seguinte_id">
                            <el-select v-model="dados.curso_seguinte_id" clearable>
                                <el-option v-for="(item, i) in selectCursos" :key="i" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">   
                    <el-col :xs="24" :sm="24" :md="24">
                        
                        <div class="titulo-list-cursos">
                            CURSOS SIMILARES
                        </div>
                        
                       <div class="list-curso">

                           <el-checkbox-group v-model="dados.similares" >
                            <ul>
                                <li v-for="(item, i) in selectCursos" :key="i">                                
                                    <el-checkbox :label="item.id" class="checkbox-list">{{ item.nome }}</el-checkbox> 
                                </li>
                            </ul>
                           </el-checkbox-group>
                       </div>                       

                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        editCurso: false,
        alert: false,
        dados: {
            id: '',
            nome: '',
            idade_minima: '',
            idade_maxima: '',
            curso_nacional_equivalente: '',
            situacao: '',
            tipo_ensino: '',
            curso_seguinte_id: '',
            similares: []
        },
        selectCursos: []

    }),
    mounted(){

        this.getAllCurso();
    },
    methods:{
        getAllCurso(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/curso/getAllCurso`, this.$store.getters.getHeaderAuth).then(response => {

                this.selectCursos = JSON.parse(JSON.stringify(response.data));
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getCursoById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/curso/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitCurso(){

            this.$refs.dados.validate((valid) =>{ if(valid){
 
                window.eventBus.$emit('loading', true);                

                if(this.editCurso){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/curso/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        
                        this.$emit('onSubmitCurso');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/curso/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                    
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$emit('onSubmitCurso');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        resetFormCurso(){
          
            this.dados = { id: '', nome: '', descricao: '', ativa: '', emDestaque: null, imagem: '' };
            this.$refs.dados.clearValidate();
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getCursoById(value);
                    this.editCurso = true;
                } 
            }
        },
    }
}
</script>
<style>

    .form-curso .titulo-list-cursos {
        background-color: #427896; padding: 5px 10px;
        color: #ffffff;
        margin-top: 10px;
    }

    .form-curso .list-curso{
        margin: 10px 0px;
    }

    .form-curso .list-curso .checkbox-list{    
        margin-left: 20px;
    }   

    .form-curso .list-curso ul {
        padding: 0;
        height: 700px;
        overflow: auto;
    }

    .form-curso .list-curso li {
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
    }

    .form-curso .list-curso{
        border: 1px solid #ccc;
    }

</style>